/*!--------------------------------------------------------
 * Copyright (C) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
/*---------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
define("vs/platform/terminal/node/ptyHostMain.nls", {
	"vs/base/common/date": [
		"in {0}",
		"now",
		"{0} second ago",
		"{0} sec ago",
		"{0} seconds ago",
		"{0} secs ago",
		"{0} second",
		"{0} sec",
		"{0} seconds",
		"{0} secs",
		"{0} minute ago",
		"{0} min ago",
		"{0} minutes ago",
		"{0} mins ago",
		"{0} minute",
		"{0} min",
		"{0} minutes",
		"{0} mins",
		"{0} hour ago",
		"{0} hr ago",
		"{0} hours ago",
		"{0} hrs ago",
		"{0} hour",
		"{0} hr",
		"{0} hours",
		"{0} hrs",
		"{0} day ago",
		"{0} days ago",
		"{0} day",
		"{0} days",
		"{0} week ago",
		"{0} wk ago",
		"{0} weeks ago",
		"{0} wks ago",
		"{0} week",
		"{0} wk",
		"{0} weeks",
		"{0} wks",
		"{0} month ago",
		"{0} mo ago",
		"{0} months ago",
		"{0} mos ago",
		"{0} month",
		"{0} mo",
		"{0} months",
		"{0} mos",
		"{0} year ago",
		"{0} yr ago",
		"{0} years ago",
		"{0} yrs ago",
		"{0} year",
		"{0} yr",
		"{0} years",
		"{0} yrs"
	],
	"vs/base/common/errorMessage": [
		"{0}: {1}",
		"A system error occurred ({0})",
		"An unknown error occurred. Please consult the log for more details.",
		"An unknown error occurred. Please consult the log for more details.",
		"{0} ({1} errors in total)",
		"An unknown error occurred. Please consult the log for more details."
	],
	"vs/base/node/processes": [
		"Can't execute a shell command on a UNC drive."
	],
	"vs/platform/environment/node/argv": [
		"Options",
		"Extensions Management",
		"Troubleshooting",
		"Compare two files with each other.",
		"Perform a three-way merge by providing paths for two modified versions of a file, the common origin of both modified versions and the output file to save merge results.",
		"Add folder(s) to the last active window.",
		"Open a file at the path on the specified line and character position.",
		"Force to open a new window.",
		"Force to open a file or folder in an already opened window.",
		"Wait for the files to be closed before returning.",
		"The locale to use (e.g. en-US or zh-TW).",
		"Specifies the directory that user data is kept in. Can be used to open multiple distinct instances of Code.",
		"Print usage.",
		"Set the root path for extensions.",
		"List the installed extensions.",
		"Show versions of installed extensions, when using --list-extensions.",
		"Filters installed extensions by provided category, when using --list-extensions.",
		"Installs or updates an extension. The argument is either an extension id or a path to a VSIX. The identifier of an extension is '${publisher}.${name}'. Use '--force' argument to update to latest version. To install a specific version provide '@${version}'. For example: 'vscode.csharp@1.2.3'.",
		"Installs the pre-release version of the extension, when using --install-extension",
		"Uninstalls an extension.",
		"Enables proposed API features for extensions. Can receive one or more extension IDs to enable individually.",
		"Print version.",
		"Print verbose output (implies --wait).",
		"Log level to use. Default is 'info'. Allowed values are 'critical', 'error', 'warn', 'info', 'debug', 'trace', 'off'.",
		"Print process usage and diagnostics information.",
		"Run CPU profiler during startup.",
		"Disable all installed extensions.",
		"Disable an extension.",
		"Turn sync on or off.",
		"Allow debugging and profiling of extensions. Check the developer tools for the connection URI.",
		"Allow debugging and profiling of extensions with the extension host being paused after start. Check the developer tools for the connection URI.",
		"Disable GPU hardware acceleration.",
		"Max memory size for a window (in Mbytes).",
		"Shows all telemetry events which VS code collects.",
		"Use {0} instead.",
		"paths",
		"Usage",
		"options",
		"To read output from another program, append '-' (e.g. 'echo Hello World | {0} -')",
		"To read from stdin, append '-' (e.g. 'ps aux | grep code | {0} -')",
		"Unknown version",
		"Unknown commit"
	],
	"vs/platform/files/common/files": [
		"Unknown Error",
		"{0}B",
		"{0}KB",
		"{0}MB",
		"{0}GB",
		"{0}TB"
	],
	"vs/platform/terminal/node/ptyService": [
		"History restored"
	],
	"vs/platform/terminal/node/terminalProcess": [
		"Starting directory (cwd) \"{0}\" is not a directory",
		"Starting directory (cwd) \"{0}\" does not exist",
		"Path to shell executable \"{0}\" is not a file or a symlink",
		"Path to shell executable \"{0}\" does not exist"
	]
});